import React,{Component} from 'react';
import $ from 'jquery';
import {Link} from 'react-router';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import ReactStars from 'react-stars';
import { Panel ,Breadcrumb } from 'react-bootstrap';
import { ShareButtons, generateShareIcon } from 'react-share';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
const baseUrl='https://aquadeals.in/admin/web3/user/';
 export default class Web_NaupliiDeals extends Component{
	constructor(props){
		super(props);
		this.state={
			seedsList: [],
			offer: {},
			sort_status: true,
			sort: '1',
			img_price: 'price.png',
			coasts: [],
			coast:'0',
			nodata: false,
			img_data: 'Price',
			open: false,
			latitude: '',
			longitude: '',
			seed_type: this.props.params.Stype,
			shareUrl: '',
			loading: false,
			web_title: '',
			web_desc: '',
			seo_title:'',
			seo_desc:'',
			cart_count:0,
			loading_gif:false,

			sortlist:[],
			total_deals:'',
		};
		this.getDeviceId=this.getDeviceId.bind(this);
		this.getCartCount=this.getCartCount.bind(this);

		this.getNearBy=this.getNearBy.bind(this);
		this.getSort=this.getSort.bind(this);
		this.getCoasts=this.getCoasts.bind(this);
		this.getSelectedCoast=this.getSelectedCoast.bind(this);
	   
	    this.getSeedFilter =this.getSeedFilter.bind(this);
	    this.getSelectedItem =this.getSelectedItem.bind(this);  
	}



	  getSeedFilter()
	  {
	     var data1 ={from:'desktop_web'};
	     var data2=JSON.stringify(data1);
	     $.ajax({
	        url:baseUrl+'seedFilters',
	        method:'POST',
	        dataType:'JSON',
	        data:{req:data2},
	        success:function(data)
	        {
	            if(data)
	            {  
	              this.setState({
	                   sortlist:data.sort,
	              });
	            }
	        }.bind(this),
	        error:function(err)
	        {

	        }
	     });
	  }
	   getSelectedItem(event)
	  {
	     // var value = event.target.value;
	     var index = event.target.selectedIndex;
	     var optionElement = event.target.childNodes[index];
	     var id =  optionElement.getAttribute('id'); 
	     var data1 ={from:'desktop_web',sort:id,coast:0,species:0,deal_type:8}
	     var data2 =JSON.stringify(data1);
	     $.ajax({
	         url:baseUrl+'getdeals',
	         method:'POST',
	         dataType:'JSON',
	         data:{req:data2},
	         success:function(data)
	         {
	            this.setState({
	                loading: true,
	                seedsList:data.data,
	                offer:data,
	              });
	         }.bind(this),
	         error:function(err)
	         {

	         }  
	     });    
	  }
	getNearBy()
	{
		this.setState({
			loading_gif:true,
		});
		
		var data1={from: 'desktop_web',lat:this.state.latitude, long:this.state.longitude,sort:this.state.sort,species:'0',deal_type:'8'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'getdeals',
			dataType: 'json',
			data:{req: data2},
			success: function(data)
			{
				if(data.data.length === 0)
				{
					this.setState({
						nodata: true,
					})
				}
				else
				{
					this.setState({
						nodata: false,
						seedsList:data.data,
	       				offer: data,
	       				web_title: data.title,
                		web_desc: data.desc,
                		loading_gif:false,
					});
					
					// document.title =this.state.web_title +  " - Deals | AquaDeals ";
     //        		document.title ="Nauplii - Deals | AquaDeals ";
					// document.getElementsByTagName("META")[2].content=this.state.seo_desc;
				}
			}.bind(this),
			error: function(err)
			{
				this.setState({
					loading_gif:false,
				});
			}.bind(this)
		});
	}
	getCoasts()
	{
		
		var data1={from: 'desktop_web',species:'0',deal_type:'8'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'coasts',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
	       			coasts:data.coasts,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}	
	getCartCount()
 	{

	    var data1={from: 'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
	    var data2=JSON.stringify(data1);
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'cart_count',
	          dataType:'json',
	          data: {req:data2},
	          success: function(data)
	          {
	            console.log(data);
	            this.setState({
	                cart_count:data.cart_count,
	            });
	          }.bind(this),
	          error: function(err){
	          
	          }
	    });
    }
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var user_id=localStorage.user_id;
	    }
	    else
	    {
	      user_id=0;
	    }
	    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	        },
	        error: function(err)
	        {
	        }
	    });
  	}
  	componentDidMount()
  	{
	  	if(screen.width < 800)
	  	{
	  		window.location.href="/nauplii";
	  	}	
  		this.setState({
  			loading_gif:true,
  		});

		    localStorage.removeItem('w_r_s_dt');
		    localStorage.removeItem('w_r_e_coupon_dt');
		    localStorage.removeItem('w_r_e_s_dt');
		    localStorage.removeItem('web_mycart');
		    localStorage.removeItem('w_r_enq_seller_page');
		    localStorage.removeItem('w_r_p_dt');
		    localStorage.removeItem('w_r_e_p_dt');
		    localStorage.removeItem('web_ofr_page');
		    localStorage.removeItem('profile');
		    localStorage.removeItem('myaquacash');
		    localStorage.removeItem('web_share_earn');
		    localStorage.removeItem('checkout');
		    localStorage.removeItem('order_details');
		    localStorage.removeItem('myorders');
		    localStorage.removeItem('w_r_p_deals');
		    localStorage.removeItem('seed');
		   
		    localStorage.removeItem('subdeals');
		    localStorage.removeItem('shipping');
		    localStorage.removeItem('notifications');
		    localStorage.removeItem('web_quickcart');
		    localStorage.removeItem('view_rating');
		    localStorage.removeItem('w_modal_seed');
		    localStorage.removeItem('w_r_seed_deals');
		    localStorage.removeItem('w_r_e_p_dt');
		    localStorage.removeItem('w_modal_details');
		    localStorage.removeItem('offers');
		    localStorage.removeItem('give_rating');
		    localStorage.removeItem('pprice');
		    localStorage.removeItem('sprice');
		    localStorage.removeItem('seed_id');
		    localStorage.removeItem('h_type');
		    localStorage.removeItem('web_pro_ofr_dtls');
		    localStorage.removeItem('web_wishlist');
		    localStorage.removeItem('web_brand_details');

		    localStorage.removeItem('m_r_s_dt');
		    localStorage.removeItem('m_r_e_coupon_dt');
		    localStorage.removeItem('m_r_e_s_dt');
		    localStorage.removeItem('mob_mycart');
		    localStorage.removeItem('m_r_enq_seller_page');
		    localStorage.removeItem('m_r_p_dt');
		    localStorage.removeItem('m_r_e_p_dt');
		    localStorage.removeItem('ofr_page');
		    localStorage.removeItem('pro_ofr_dtls');

		    localStorage.removeItem('share_earn');
		    localStorage.removeItem('my_orders');
		    localStorage.removeItem('m_r_p_deals');
		    localStorage.removeItem('mob_quickcart');
		    localStorage.removeItem('partner_deals');

 		
		this.getDeviceId();
  		if(localStorage.user_id && localStorage.token)
  		{
  			this.getCartCount();
  		}
  		if(!localStorage.user_id && !localStorage.token)
	  	{
	  		localStorage.setItem('nauplii','/web/nauplii/nauplii/8');
	  	}
  		this.getCoasts();
  		
		var data1={from: 'desktop_web',coast:'0',species:'0',deal_type:'8'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data:{req:data2},
      		success: function(data)
      		{
        		this.setState({
        			seedsList:data.data,
	       			offer: data,
	       			web_title: data.title,
	       			web_desc: data.desc,
	       			loading:true,
	       			seo_title:'Nauplii deals from Hatcheries',
	       			seo_desc:'Browse quality Nauplii deals from CAA approved Hatcheries, shop online and avail free shipment.',
	       			loading_gif:false,
	       		   total_deals:data.total_records,
	       		});
		       	// document.title =this.state.web_title+  " - Deals | AquaDeals | "+this.state.seo_desc;
		       	document.title =this.state.seo_title;
	            document.getElementsByTagName("META")[2].content=this.state.seo_desc;
			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  				this.setState({
  					loading_gif:false,
  				});
  			}
        });
        this.getSeedFilter();
  	}
 	getSort()
	{
		localStorage.setItem('sort',this.state.sort);
		
		var data1={from: 'desktop_web',sort:this.state.sort,coast:this.state.coast,species:'0',deal_type:'8'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		if(this.state.sort === 1)
	    		{
	    			var ss = 2;
	    			var img_price = 'down.png';
	    			var img_data = 'High - Low';
	    		}
	    		else
	    		{
	    			 ss = 1;
	    			 img_price = 'up.png';
	    			 img_data ='Low - High';
	    		}
	    		this.setState({
        			sort: ss,
					img_price: img_price,
					img_data: img_data,
	       			seedsList:data.data,
	       			offer: data,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}
	getSelectedCoast(c)
	{
		if(this.state.sort === 1)
		{
			this.setState({
				sort: '2',
			});
		}
		else
		{
			this.setState({
				sort:'1',
			})
		}
		this.setState({
			coast:c,
		});
		
		var data1={from: 'desktop_web',coast: c,sort:localStorage.sort,species:'0',deal_type:'8'};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdeals',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		if(data.data.length === 0)
        		{
        			this.setState({
        				nodata: true,
        			})
        		}
        		else
        		{
        			this.setState({
        				nodata: false
        			})
        		}
        		this.setState({
	       			seedsList:data.data,
	       			offer: data,

	       		});
			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
	}


	render()
	{
      var seedFilters = this.state.sortlist.map(function(item,index){
         return(
              <option key={item.id} value={item.type} id={item.id}>{item.type}</option>   
          );
      });


		var products = this.state.seedsList.map((product, index) => (<Product key={product.deals_data.id} data={product} />));
		// return(
		// 	<div className="mob_deals">
		// 		<div className="seed_list_page">
		// 			<div className="page_hdr">
		// 				<div className="container-fluid">
		// 					<h5><Link to={"/home"}><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/arrow_back.png'} width="30px" alt=""/></i></Link>Nauplii</h5>
		// 					<a href="/home" className="home_logo1"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home" /></a>
		// 					<a className="mob_cart_btn" href="/mycart">
		// 						<img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
		// 						{this.state.cart_count > 0 ? <span className={this.state.cart_count > 9 ? "mob_cart_count1" : "mob_cart_count"}>{this.state.cart_count}</span> : ''}
		// 					</a>
		// 				</div>
		// 			</div>
		// 			<div className="pag_cntnt">&nbsp;</div>
		// 			<section>
		// 					<div className="no_data">
		// 						<h3>No Deals Available</h3>
		// 						<p>Need some thing here? <Link to={"/web/customer_care"}>CONTACT US</Link> now !</p>
		// 					</div>
		// 			</section>
		// 		</div>
		// 	</div>
		// );
		return (

		<div className="web_deals web_seedslist_page">
		  <div className="clr">&nbsp;</div>
		  <div className="clr">&nbsp;</div>
		  <div className="clr">&nbsp;</div>	
			{this.state.loading ?
				<div className="lgt_gry">
					<WebHeaderInner/>
					<div className="clr">&nbsp;</div>
            		<section className="container pro_lst_cntnt">
            		   <div className="container"> 
	                     <Breadcrumb className="webpdeals_breadcrmb">
	                      <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
	                      <Breadcrumb.Item active>{this.state.web_title}</Breadcrumb.Item>
	                     </Breadcrumb>
                      </div>
                      <div className="tot_pro">
                        <div className="row" style={{marginRight:'0 !important'}}>
                          {/*<!-- filters start --> */}
		                     <div className="col-md-3 col-sm-3">
		                        <div className="filtrs_blk">
		                           <h3>Categories</h3>
		                           	 <ul>
            				 			<li className="fltr_title">Nauplii</li>
            				 		 </ul>
                                </div>
                             </div>   
                              <div className="pro_sec col-md-9 col-sm-9">
                                   {/*  <!-- products section header start --> */}
	                           <div className="pro_sec_hdr">
	                             <h3>{this.state.web_title}<span>&nbsp;({this.state.total_deals} Items)</span></h3>
		                              <div className="pro_slt_fltr">
		                                <select onChange={this.getSelectedItem}>
		                                  <option>Select</option>
                                          {seedFilters}
                                        </select>
		                              </div>
                               </div>
                                {/*  <!-- products section header end --> */}
                                {/* <!-- products blocks start --> */}
                                {this.state.loading ?
    				 				<div className="row itm_lst">
    				 					{products.length >0 ? products : <div className="seed_no_data">No Deals Available</div>}
    				 				</div>
    				 			:
    				 				<div className="loading_sym">
    				 					<img src={'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader.gif'} alt="AquaDeals" role="presentation" />
    				 				</div>
            				 	}
            				 </div>
            			</div> 	 	
                     </div>
                   </section>
                   <WebFooter/>
                </div>   :
                <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:20+'%'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /> </div>
            }
            </div>
      );
    }		
  }
export class Product extends Component{
	constructor(){
		super();
		this.state={
			open: false,
			shareUrl: '',
			msg: '',
		};
		this.ShareFunc=this.ShareFunc.bind(this);
	}

	ShareFunc(evnt)
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'desktop_web',type:0,did:evnt};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'createTinyurl',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
        			msg: data.msg,
        			shareUrl: data.tinyurl,
        		})
        	}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        });
		this.setState({
			open: !this.state.open 
		});
		setTimeout(() => {this.setState({open: false}); }, 5000);
	}
	render()
	{
		var mydata=this.props.data;
		// var shareUrl = 'http://203.193.173.125:3003/seed_details/'+mydata.deals_data.id;
		var shareUrl = this.state.shareUrl;
		var title = "Hey Click here "+ shareUrl  + " to check " + mydata.deals_data.sname + " from AquaDeals.";
		var description=shareUrl;
		// var title = this.state.msg;
		var no_data='';
		if(mydata.length === 0){
			no_data= <div className="no_data">
					<h3>No Deals Available</h3>
					<p>Need some thing here? <Link to={"/web/customer_care"}>CONTACT US</Link> now !</p>
					</div>;
		}
		else{
			no_data="";
		}

		return(
		<div className="col-md-3 col-sm-6">
			{no_data}
			<div className="prdt_blk">
			   <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(mydata.deals_data.id)}}>
                	<img src={'https://aquadeals.in/admin/assets/images/web_imgs/share.png'} alt="Share" />
            	</Link>
            	<Panel className="share_panel" collapsible expanded={this.state.open}>
	                 <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share">
	                        <FacebookIcon size={32} round />
	                 </FacebookShareButton>
	                 <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share">
	                        <TwitterIcon size={32} round />
	                 </TwitterShareButton>
	                 <GooglePlusShareButton url={shareUrl} quote={title} descirption={description} className="test_share">
	                        <GooglePlusIcon  size={32} round />
	                 </GooglePlusShareButton>
	            </Panel>
                 <Link className='cursor' to={"/web/sdetails/"+mydata.deals_data.sname+"/"+mydata.deals_data.id}>  
                 	<div className="itm_img">
						<img src={'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/'+mydata.deals_data.image} alt="AquaDeals" role="presentation" />
					</div>
					{mydata.deals_data.sname ? <h3>{mydata.deals_data.sname}</h3> : <h3>&nbsp;</h3>}
             		{mydata.deals_data.discount_price > 0 ? <h4><span></span><span>&#8377; {mydata.offer}</span> off on 1M</h4> : <h4>&nbsp;</h4>}
             		{mydata.deals_data.price ? <h4><span></span><span style={{color:'#333'}}>&#8377;</span><span style={{color:'#333'}}> {mydata.deals_data.price}</span></h4> : <h4>&nbsp;</h4>}  
                 </Link>
				<div className="row stars_view_blk">
                      <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                        <div className="prdt_str_rt">
					      <ReactStars
                              count={5}
                              className={'webRate_blk_item'}
                              size={17}
                              value={mydata.deals_data.rate >=1  ? mydata.deals_data.rate : 0}
                              edit={false}
                              color1={'#ccc'}
                              color2={'#ffc50a'}
                          />
					   </div>
                      </div>
					  <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
                         {mydata.view_status >0 ? <span className="prdt_views"><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/eye.png'} width="16px" role="presentation"/></i>&nbsp;{mydata.view_status}</span> : ''}
                      </div>
           			<div className="clr"></div>
		        </div>
		   </div>
        </div>
		
		);
	}
}

// export default connect(mapStateToProps,actions)(Web_NaupliiDeals);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Seed/Web_NaupliiDeals.js
 **/